import { Directive, DoCheck, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";
import { HandleChangeService } from "./handle-change.service";
import { Router } from "@angular/router";
import { CustCardTabService } from "../Custcard/cust-card-tab/cust-card-tab.service";

@Directive({
    selector: "[appHostListenerBeforeUnload]",
    exportAs: "hostListenerBeforeUnload"
})
export class HostListenerBeforeUnloadDirective implements OnInit, DoCheck {
    @Input() receivedData: any;
    @Input() saveData: boolean;
    @Output() componentHasChangedOutput = new EventEmitter<boolean>();

    currentData: string = null;
    previousData: string = null;
    isLoaded: boolean = false;

    componentHasChanged: boolean = false;

    constructor(private handleChangeService: HandleChangeService,
        private router: Router,
        private custCardTabService: CustCardTabService) {
        custCardTabService.tabChanged.subscribe((tabIndex: number) => this.resetComponentHasChanged());
    }

    ngOnInit(): void {
        this.handleChangeService.handleChange(this.router.url, false);
    }

    ngDoCheck(): void {
        if (this.currentData != JSON.stringify(this.receivedData)) {
            if (this.previousData !== this.currentData) {
                this.previousData = this.currentData;
            }
            this.currentData = JSON.stringify(this.receivedData);
        }

        if (this.previousData !== this.currentData && !this.isLoaded) {
            this.previousData = this.currentData;
            this.isLoaded = true;
        }

        if (this.previousData !== this.currentData && !this.componentHasChanged) {
            this.componentHasChangedOutput.emit(true);
            this.componentHasChanged = true;
            this.handleChangeService.handleChange(this.router.url, true);
        }
    }

    resetComponentHasChanged(): void {
        this.previousData = this.currentData;
        this.componentHasChangedOutput.emit(false);
        this.componentHasChanged = false;
        this.handleChangeService.handleChange(this.router.url, false);
    }

    // Reload and close
    @HostListener("window:beforeunload", ["$event"])
    onBeforeUnload(event: BeforeUnloadEvent) {
        console.log(this.receivedData)
        console.log(this.componentHasChanged)
        if (event && !this.saveData && this.componentHasChanged) {
            event.preventDefault();
            event.returnValue = "";
            return event;
        }
        return true;
    }
}
